// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"d7f830df1b6e66359467","551":"b3c0e9c1fd60c47d1434"}[chunkId] + ".css";
};